import { ar, fa, ur } from './rtl.js';
import { es, fr, it, pt } from './westEurope.js';
import { pl, ro, tr } from './eastEurope.js';
import { bn, gu, pa } from './southAsia.js';
import { so, tl, zh } from './other.js';
import { WAVE2B_TERMINOLOGY_PHRASE_IDS, WAVE2B_TERMINOLOGY_TRANSLATIONS } from './wave2b.js';

const BASE_TERMINOLOGY_TRANSLATIONS = { ar, bn, es, fa, fr, gu, it, pa, pl, pt, ro, so, tl, tr, ur, zh };

export const JOURNEY_TERMINOLOGY_PHRASE_TRANSLATIONS = Object.freeze(Object.fromEntries(
  Object.entries(BASE_TERMINOLOGY_TRANSLATIONS).map(([language, phrases]) => [
    language,
    Object.freeze({ ...phrases, ...(WAVE2B_TERMINOLOGY_TRANSLATIONS[language] || {}) }),
  ]),
));

export const JOURNEY_TERMINOLOGY_PHRASE_IDS = Object.freeze([
  'anaesthesia',
  'proceduralSedation',
  'ambulatoryCare',
  'antenatalCare',
  'contrast',
  'claustrophobia',
  'dischargeCriteria',
  'surgicalDrain',
  'prognosis',
  'systemicAntiCancerTreatment',
  'palliativeCare',
  'patientInitiatedFollowUp',
  'cancerRecurrenceSurveillance',
  'neurophysiologyTests',
  'thrombolysis',
  'thrombectomy',
  'exacerbation',
  'gastroscopyColonoscopy',
  'bowelPreparation',
  'bloodGlucose',
  'clinician',
  'diagnosis',
  'investigations',
  'inpatientOutpatient',
  'acuteCare',
  'primaryCare',
  'carePathway',
  'orthopaedics',
  ...WAVE2B_TERMINOLOGY_PHRASE_IDS,
]);
